import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import { connect } from 'react-redux';

import _ from 'lodash';
import queryString from 'query-string';

import BasAgentsCard from './BasAgentsCard';
import ErpAgentsCard from './ErpAgentsCard';
import ProtectedRoute from '../../components/ProtectedRoute';

import AgentLogsPage from './AgentLogsPage';
import AgentLogDataPage from './AgentLogDataPage';
import AgentNetworkPage from './AgentNetworkPage';
import BacnetInventoryPage from './BacnetInventoryPage';
import BasAgentsPage from './BasAgentsPage';
import ConfigureErpAgentPage from './ConfigureErpAgentPage';
import ErpAgentsPage from './ErpAgentsPage';
import ManageBasAgentPage from './ManageBasAgentPage';
import ManageErpAgentPage from './ManageErpAgentPage';
import ManageProfilePage from './ManageProfilePage';
import InventoryPage from './InventoryPage';
import BacnetProfileCreatePage from './BacnetProfileCreatePage';
import NiagaraProfileCreatePage from './NiagaraProfileCreatePage';
import ProfilesPage from './ProfilesPage';
import UseExistingProfilesPage from './UseExistingProfilesPage';
import UseExistingBacnetProfilePage from './UseExistingBacnetProfilePage';
import ViewAgentLogsPage from './ViewAgentLogsPage';

import classes from './IoTHub.module.css';

import * as BasAgentActions from '../../actions/basAgentActions';
import * as ErpAgentActions from '../../actions/erpAgentActions';
import * as ProfileActions from '../../actions/profileActions';
import DownloadsPage from './DownloadsPage';

class IoTHub extends Component {
    componentDidMount() {
        const queryValues = queryString.parse(this.props.history.location.search);

        if (_.isEmpty(this.props.basAgents)) {
            this.props.fetchBasAgents(queryValues.company);
        }

        if (process.env.erpAgentEnabled && _.isEmpty(this.props.erpAgents)) {
            this.props.fetchErpAgents(queryValues.company);
        }

        if (_.isEmpty(this.props.profiles)) {
            this.props.fetchProfiles(queryValues.company);
        }
    }

    componentWillUnmount() {
        const { pathname } = this.props.history.location;
        const params = new URLSearchParams(this.props.history.location.search);

        params.delete('basAgent');

        this.props.setBasAgents([]);
        this.props.setErpAgents([]);

        this.props.history.push(`${pathname}?${params.toString()}`);
    }

    render() {
        let { currentScopes } = this.props;

        if (!currentScopes) {
            return null;
        }

        return (
            <div className={classes.IoTHub}>
                <Switch>
                    <ProtectedRoute
                        component={AgentNetworkPage}
                        path="/iothub/basagents/manage/network"
                        permissions="iothubFull"
                    />

                    <ProtectedRoute
                        component={InventoryPage}
                        path="/iothub/basagents/manage/inventory/niagara"
                        permissions="iothubRead"
                    />

                    <ProtectedRoute
                        component={BacnetInventoryPage}
                        path="/iothub/basagents/manage/inventory/bacnet"
                        permissions="iothubRead"
                    />

                    <ProtectedRoute
                        component={AgentLogDataPage}
                        path="/iothub/basagents/manage/logs/advanced/log"
                        permissions="iothubRead"
                    />

                    <ProtectedRoute
                        component={ViewAgentLogsPage}
                        path="/iothub/basagents/manage/logs/classic"
                        permissions="iothubRead"
                    />

                    <ProtectedRoute
                        component={AgentLogsPage}
                        path="/iothub/basagents/manage/logs/advanced"
                        permissions="iothubRead"
                    />

                    <ProtectedRoute
                        component={ManageBasAgentPage}
                        path="/iothub/basagents/manage"
                        permissions="iothubRead"
                    />

                    <ProtectedRoute
                        component={ManageErpAgentPage}
                        path="/iothub/erpagents/manage"
                        permissions="iothubRead"
                    />

                    <ProtectedRoute
                        component={ConfigureErpAgentPage}
                        path="/iothub/erpagents/configure"
                        permissions="iothubRead"
                    />

                    <ProtectedRoute
                        component={BasAgentsPage}
                        path="/iothub/basagents/"
                        permissions="iothubRead"
                    />

                    <ProtectedRoute
                        component={ErpAgentsPage}
                        path="/iothub/erpagents/"
                        permissions="iothubRead"
                    />

                    <ProtectedRoute
                        component={UseExistingProfilesPage}
                        path="/iothub/profiles/niagara/existing"
                        permissions="iothubRead"
                    />

                    <ProtectedRoute
                        component={UseExistingBacnetProfilePage}
                        path="/iothub/profiles/bacnet/existing"
                        permissions="iothubRead"
                    />

                    <ProtectedRoute
                        component={ManageProfilePage}
                        path="/iothub/profiles/manage"
                        permissions="iothubRead"
                    />

                    <ProtectedRoute
                        component={BacnetProfileCreatePage}
                        path="/iothub/profiles/bacnet/new"
                        permissions="iothubRead"
                    />

                    <ProtectedRoute
                        component={NiagaraProfileCreatePage}
                        path="/iothub/profiles/niagara/new"
                        permissions="iothubRead"
                    />

                    <ProtectedRoute
                        component={ProfilesPage}
                        path="/iothub/profiles/"
                        permissions="iothubRead"
                    />

                    <ProtectedRoute
                        component={DownloadsPage}
                        path="/iothub/downloads/"
                        permissions="iothubRead"
                    />

                    <Route path="/iothub/" >
                        <div className={classes.cardsContainer}>
                            <BasAgentsCard />
                            {
                                process.env.erpAgentEnabled &&
                                <ErpAgentsCard />
                            }
                        </div>
                    </Route>
                </Switch>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        basAgents:     Object.values(state.basAgent.basAgents),
        currentScopes: state.core.currentScopes,
        erpAgents:     Object.values(state.erpAgent.erpAgents),
        profiles:      state.profile.profiles
    };
};

const mapDispatchToProps = {
    ...BasAgentActions,
    ...ErpAgentActions,
    ...ProfileActions
};

export default connect(mapStateToProps, mapDispatchToProps)(IoTHub);
